import { render, staticRenderFns } from "./pacchetti.vue?vue&type=template&id=09947c8d&scoped=true&"
import script from "./pacchetti.vue?vue&type=script&lang=js&"
export * from "./pacchetti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09947c8d",
  null
  
)

export default component.exports